<template>
  <v-chip
    @click:close="closeFunction(...closeFunctionParameters)"
    :close="close"
    close-icon="mdi-close"
    :outlined="outlined"
    color="primary"
    label
    :large="large"
    :link="link"
    :class="`${!computedLoading && ((showLogicalLanguage && !computedProlog) || (!showLogicalLanguage && !computedName)) ? 'rai-custom-chip__red-border' : ''} px-6 mr-3 my-1`"
    :disabled="disabled"
  >
    <span class="rai-custom-loader__button" v-show="computedLoading">
      <v-icon dark>mdi-cached</v-icon>
    </span>
    <v-icon
      v-show="!computedLoading"
      v-if="edit"
      @click="editFunction(...editFunctionParameters)"
      left
      small
    >
      mdi-pencil-outline
    </v-icon>
    <span v-show="!computedLoading">
      {{ !showLogicalLanguage ? computedName || $t('global.notranslation') : computedProlog || $t('global.notranslation') }}
    </span>
  </v-chip>
</template>

<script>
export default {
  name: 'OptionChip',

  props: {
    option: {
      type: Object,
      required: false,
    },
    close: {
      type: Boolean,
      required: false,
      default: false,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    editFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    closeFunctionParameters: {
      type: Array,
      required: false,
      default: () => {},
    },
    editFunctionParameters: {
      type: Array,
      required: false,
      default: () => {},
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    link: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    showLogicalLanguage () {
      return this.$store.state.showLogicalLangage;
    },

    computedLoading () {
      if (this.option) {
        return this.option.loading
      }
      return false
    },

    computedName () {
      if (this.option) {
        return this.option.name
      }
      return ''
    },

    computedProlog () {
      if (this.option) {
        return this.option.prolog
      }
      return ''
    }
  },
};
</script>

<style>
.rai-custom-chip.v-chip .v-chip__content .rai-natural-language{
  position: relative;
  top: 5px;
}

.rai-custom-chip.v-chip .v-chip__content .rai-logical-language{
  position: relative;
  top: 5px;
}

.rai-custom-chip.v-chip .v-chip__content {
  display: inline;
}

.rai-custom-chip.v-chip .v-chip__close {
  float: right;
  right: -14px;
}

.rai-custom-chip__red-border.v-chip {
  box-shadow: 0 0 0 1pt red;
}
</style>